import React, { useState, useEffect }  from 'react';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { useCompleteSignIn } from '../../hooks/authhooks';
import BusinessTabs from '../../molecules/Desktop/BusinessTabs';
import { BusinessStageType, BusinessTabType, FocusGroupSessionSchema, SearchFilterOptionType } from '../../data/types';
// import { MOCK_FOCUS_GROUPS } from '../../data/focus_groups_sessions';
import { useFocusGroupSession, useFocusGroupFormattedSessions } from '../../hooks/businesshooks';
import moment from 'moment-timezone';
import { formatDuration, capitalizeString, capitalizeWords } from '../../utils/helpers';


type RouteParams = { 
    sessionId: string
  };

// const formatDuration = (minutes: number): string => {
//     if (minutes < 60) {
//         return `${minutes} min`;
//     } else if (minutes < 1440) { // Less than 24 hours
//         const hours = Math.floor(minutes / 60);
//         return `${hours} ${hours === 1 ? 'hr' : 'hrs'}`;
//     } else if (minutes < 10080) { // Less than 7 days
//         const days = Math.floor(minutes / 1440);
//         return `${days} ${days === 1 ? 'day' : 'days'}`;
//     } else if (minutes < 43200) { // Less than 30 days
//         const weeks = Math.floor(minutes / 10080);
//         return `${weeks} ${weeks === 1 ? 'week' : 'weeks'}`;
//     } else { // 30+ days
//         const months = Math.floor(minutes / 43200);
//         return `${months} ${months === 1 ? 'month' : 'months'}`;
//     }
// };

type FocusGroupProps = {
    searchFilterOptions?: SearchFilterOptionType
}

const FocusGroupAccess: React.FC<FocusGroupProps> = ({searchFilterOptions}) => {
    const {setSignInModalIsOpen } = searchFilterOptions || {setSignInModalIsOpen: () => {}}
    const navigate = useNavigate();
    const { user } = useCompleteSignIn(); 
    const isLoggedIn = !!user?.username && !!user?.uid;
    // const username = user?.username || '';
    const uid = user?.uid || '';

    const [searchParams] = useSearchParams();
    const [width, setWidth] = useState<number>(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isMobile = width < 1024;

    const { sessionId } = useParams<RouteParams>()
    const homeQuery = searchParams.get('home');
    const stage = searchParams.get('stage');
    const [businessStage, setBusinessStage] = useState<BusinessStageType>(stage as BusinessStageType || 'dream');

    const startTab = {
        dream: 'focus-group', 
        build: 'focus-group', 
        scale: 'focus-group'
    } as BusinessTabType

    // const communityId = ""
    const { formattedFocusGroupSessions } = useFocusGroupFormattedSessions()

    // const liveSessions = MOCK_FOCUS_GROUPS.filter(session => session.id === sessionId) as FocusGroupSchema[];
    const session = formattedFocusGroupSessions.find(session => session.id === sessionId) as FocusGroupSessionSchema;
    const sessionDuration = session ? session?.duration : 0

    const isManualLive = false
    const orgName = session?.orgName;
    const OrgLogo = session?.orgLogo;
    const sessionDate = session?.sessionDate;
    const now = moment();

    const { pastSessionResponse } = useFocusGroupSession(uid, session ? session.id : '');
    const sessionTypeName = (session && session?.sessionType) ? capitalizeWords(session?.sessionType?.split('_').join(' ')) : 'Focus Group'
    // console.log('pastSessionResponse', pastSessionResponse)
    // const sessionDate = new Date('2026-03-20T14:00:00Z'); // Example session date
    // const sessionDate = new Date('2025-03-20T14:00:00Z');
    // const sessionDate = new Date('2024-03-20T14:00:00Z');

    useEffect(() => {
        // Ensure document title is always overridden with a valid value, replacing any previous title
        const sessionNumber = session?.sessionNumber ? ` ${session.sessionNumber}` : '';
        document.title = `${orgName} ${sessionTypeName} Session ${sessionNumber}`;
    }, [orgName, sessionTypeName, session?.sessionNumber])

    if (!session) {
        return (
            <div className="flex flex-col min-h-screen bg-white">
                {isLoggedIn && <BusinessTabs startTab={startTab} businessStage={businessStage} setBusinessStage={setBusinessStage} />}
                <div className={`flex flex-col ${isLoggedIn ? '' : 'mt-[60px]'}`}>
                    <div className={`${isMobile ? 'max-w-full px-4' : 'max-w-4xl px-6'} mx-auto w-full py-8`}>
                        <div className="mb-6">
                            <button
                                onClick={() => {
                                    if (isLoggedIn) {
                                        navigate('/focus-group')
                                    } else {
                                        setSignInModalIsOpen(true)
                                    }
                                }}
                                className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group shadow-sm hover:shadow"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 group-hover:text-primaryDark-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                <span className="font-medium">Back to All Sessions</span>
                            </button>
                        </div>
                        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                            <div className="space-y-6">
                                <div className="p-6 bg-red-50 rounded-lg border border-red-100">
                                    <div className="flex items-start space-x-4">
                                        <div className="p-2 bg-red-100 rounded-lg">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                            </svg>
                                        </div>
                                        <div className="flex-1">
                                            <h3 className="text-lg font-semibold text-gray-900 mb-2">Invalid Session</h3>
                                            <div className="space-y-3">
                                                <p className="text-gray-600">
                                                    The session you're trying to access doesn't exist or has been removed.
                                                </p>
                                                <p className="text-gray-600">
                                                    Please check the session link or return to all sessions listings to find an available session.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => {
                                        if (isLoggedIn) {
                                            navigate('/focus-group')
                                        } else {
                                            setSignInModalIsOpen(true)
                                        }
                                    }}
                                    className="w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200"
                                >
                                    View Available Sessions
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <div className="flex flex-col min-h-screen bg-white">
            {isLoggedIn && <BusinessTabs startTab={startTab} businessStage={businessStage} setBusinessStage={setBusinessStage} />}
            <div className={`flex flex-col ${isLoggedIn ? '' : `${isMobile ? 'mt-[160px]' : 'mt-[60px]'}`}`}>
                    <div className={`${isMobile ? 'max-w-full px-4' : 'max-w-4xl px-6'} mx-auto w-full py-8`}>
                        {
                         (homeQuery) ? (<></>): (<div className="mb-6">
                            <button
                                onClick={() => {
                                    if (isLoggedIn) {
                                        navigate('/focus-group')
                                    } else {
                                        setSignInModalIsOpen(true)
                                    }
                                }}
                                className="flex items-center space-x-2 px-4 py-2.5 bg-gray-50 hover:bg-gray-100 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 group-hover:text-gray-700 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                <span className="font-medium">Back to All Sessions</span>
                            </button>
                        </div>)
                        }
                        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
                            <div className={`flex ${isMobile ? 'flex-col' : 'items-center space-x-6'} mb-8`}>
                                <img src={OrgLogo} alt={orgName} className={`${isMobile ? 'w-16 h-12 mb-4' : 'w-20 h-16'} object-contain`} />
                                <div className="flex-1">
                                    <div className={`flex ${isMobile ? 'flex-col' : 'items-center space-x-3'} mb-2`}>
                                        <h2 className={`${isMobile ? 'text-2xl mb-2' : 'text-3xl'} font-bold text-gray-900`}>{orgName} {sessionTypeName}</h2>
                                        {now.isSameOrAfter(sessionDate) && (
                                            <span className={`${isMobile ? 'self-start' : ''} px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-sm font-medium inline-block`}>
                                                {sessionTypeName} #{session?.sessionNumber}
                                            </span>
                                        )}
                                    </div>
                            
                                    <h3 className={`${isMobile ? 'text-lg' : 'text-xl'} font-semibold text-gray-800 mb-1`}>{session?.title}</h3>
                                    <p className="text-gray-600 mb-2">{session?.description}</p>
                                      


                                    {now.isSameOrAfter(sessionDate) && (
                                        <>
                                        <div className={`flex ${isMobile ? 'flex-col space-y-2' : 'items-center space-x-4'} text-sm text-gray-500`}>
                                            <span className="flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                                {sessionDate?.format('dddd, MMMM D, YYYY')}
                                            </span>
                                            <span className="flex items-center">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                {sessionDate?.format('h:mm A')}
                                                <span className="text-gray-400 ml-1">
                                                    • {formatDuration(sessionDuration)}
                                                </span>
                                            </span>
                                        </div>
                                        </>
                                    )}

                                </div>
                            </div>
                            
                            {(() => { 
                                if (pastSessionResponse && now.isSameOrAfter(sessionDate)) {
                                    return (
                                        <div className="space-y-6">
                                            <div className="p-6 bg-purple-50 rounded-lg border border-purple-100">
                                                <div className="flex items-start space-x-4">
                                                    <div className="p-2 bg-purple-100 rounded-lg">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                        </svg>
                                                    </div>
                                                    <div className="flex-1">
                                                        <h3 className="text-lg font-semibold text-gray-900 mb-2">{sessionTypeName} Completed</h3>
                                                        <p className="text-gray-600">You have already participated in this {sessionTypeName.toLowerCase()}. Thank you for your contribution!</p>
                                                        <div className="mt-4 space-y-2">
                                                            <div className="flex items-center text-purple-700">
                                                                <span className="font-medium">Date Attended:</span>
                                                                <span className="ml-2">{sessionDate?.format('dddd, MMMM D, YYYY')}</span>
                                                            </div>
                                                            <div className="flex items-center text-purple-700">
                                                                <span className="font-medium">Time:</span>
                                                                <span className="ml-2">{sessionDate?.format('h:mm A')}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {
                                                        session?.resource_id && session?.resource_type && (
                                                            <button 
                                                                onClick={() => navigate(`/${session?.resource_type}/${session?.resource_id}`)}
                                                                className="bg-primaryDark-0 hover:bg-primaryDark-100 text-sm  text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200 my-auto"
                                                            >
                                                                View {capitalizeString(session?.resource_type)}
                                                            </button>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <button 
                                                onClick={() => navigate('/focus-group')}
                                                className="w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200"
                                            >
                                                View Other Sessions
                                            </button>
                                        </div>
                                    );
                                } else if (session && now.isBefore(sessionDate)) {
                                    return (
                                        <div className="space-y-6">
                                            <div className="p-6 bg-blue-50 rounded-lg border border-blue-100">
                                                <div className={`flex ${isMobile ? 'flex-col space-y-4' : 'items-start space-x-4'}`}>
                                                    <div className={`p-2 bg-blue-100 rounded-lg ${isMobile ? 'self-start' : ''}`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                        </svg>
                                                    </div>
                                                    <div className="flex-1">
                                                        <h3 className={`${isMobile ? 'text-xl' : 'text-lg'} font-semibold text-gray-900 mb-2`}>Upcoming {sessionTypeName}</h3>
                                                        <div className="space-y-3">
                                                            <div className={`flex ${isMobile ? 'flex-col space-y-1' : 'items-center'} text-blue-700`}>
                                                                <span className="font-medium">Starts on:</span>
                                                                <span className={`${isMobile ? '' : 'ml-2'}`}>{sessionDate.format('dddd, MMMM D, YYYY')}</span>
                                                            </div>
                                                            <div className={`flex ${isMobile ? 'flex-col space-y-1' : 'items-center'} text-blue-700`}>
                                                                <span className="font-medium">Time:</span>
                                                                <span className={`${isMobile ? '' : 'ml-2'}`}>{sessionDate.format('h:mm A')}</span>
                                                            </div>
                                                        </div>
                                                        <p className="mt-4 text-gray-600">Please return at the scheduled time to join the live session.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <button 
                                                disabled
                                                className={`w-full bg-gray-100 text-gray-500 px-6 ${isMobile ? 'py-4' : 'py-3.5'} rounded-lg font-semibold cursor-not-allowed`}
                                            >
                                                {sessionTypeName} Not Started Yet
                                            </button>
                                        </div>
                                    );
                                } else if (session && (isManualLive || (now.isSameOrAfter(sessionDate) && now.isSameOrBefore(moment(sessionDate).add(sessionDuration, 'minutes'))))) {
                                    return (
                                        <div className="space-y-6">
                                            <div className={`flex ${isMobile ? 'flex-col space-y-3' : 'items-center justify-between'} p-4 bg-gray-50 rounded-lg border border-gray-200`}>
                                                <div className="flex items-center space-x-3">
                                                    <div className="w-2.5 h-2.5 bg-green-500 rounded-full animate-pulse"></div>
                                                    <span className="text-gray-700 font-medium">{sessionTypeName} Status:</span>
                                                </div>
                                                <span className={`text-green-600 font-semibold bg-green-50 px-4 py-1.5 rounded-full border border-green-100 ${isMobile ? 'inline-block text-center' : ''}`}>Live Now</span>
                                            </div>
                                            <button 
                                                onClick={() => {
                                                    if (isLoggedIn || session?.allowAnonymous) {
                                                        navigate(`/focus-group/${sessionId}/session`)
                                                    } else {
                                                        setSignInModalIsOpen(true)
                                                    }
                                                }}
                                                className={`w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 ${isMobile ? 'py-4' : 'py-3.5'} rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200`}
                                            >
                                                Start {sessionTypeName}
                                            </button>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div className="space-y-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                            <div className="text-gray-700">
                                                <p className={`font-medium ${isMobile ? 'text-lg' : ''}`}>This {sessionTypeName.toLowerCase()} has ended.</p>
                                                <p className={`mt-2 text-gray-600 ${isMobile ? 'text-base' : ''}`}>Please check the schedule for upcoming sessions.</p>
                                            </div>
                                        </div>
                                    );
                                }
                            })()}
                        </div>
                    </div>
              
            </div>
        </div>
    );
}

export default FocusGroupAccess;